import AlignCenter from "../../icons/AlignCenter";
import AlignLeft from "../../icons/AlignLeft";
import AlignRight from "../../icons/AlignRight";
import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";

export const ALIGNMENT_OPTIONS = [
  { icon: AlignLeft, value: "left" },
  { icon: AlignCenter, value: "center" },
  { icon: AlignRight, value: "right" },
];

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const ASPECT_RATION_OPTIONS = [
  { label: "Original", i18n: "original", value: "original" },
  { label: "Squared", i18n: "squared", value: "squared" },
];

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 32 },
];
